import API from '@/axios'
const EndpointFinancial = '/financial'
const EndpointPayment = '/payments'
const EndpointMethods = '/methods'
const EndpointMany = '/many'

export default {
	async getPayments(params) {
		const queryParams = {
			search: params?.search,
			entity_id: params?.entity_id,
			entity_type: params?.entity_type,
			has_bill: params?.has_bill,
			payer_id: params?.payer_id,
			page: params?.page,
			limit: params?.limit,
			orderBy: params?.orderBy,
			orderDirection: params?.orderDirection,
			created_at_from: params?.created_at_from,
			created_at_to: params?.created_at_to,
			withDeleted: params?.withDeleted,
			payment_method_id: params?.payment_method_id,
		}

		if (params?.includeValueAggregations) {
			queryParams.includeValueAggregations = params.includeValueAggregations
		}

		return await API.get(EndpointFinancial + EndpointPayment, {
			params: queryParams,
		}).then((response) => response)
	},

	async getManyEntityPayments(entity_ids, entity_type) {
		return await API.get(EndpointFinancial + EndpointPayment + EndpointMany, {
			params: {
				entity_ids,
				entity_type,
			},
		}).then((response) => response)
	},

	async getPaymentMethods() {
		return await API.get(EndpointFinancial + EndpointPayment + EndpointMethods).then(
			(response) => response
		)
	},

	async createPayment(payload) {
		return await API.post(EndpointFinancial + EndpointPayment, payload, {
			headers: {
				'content-type': 'multipart/form-data',
			},
		}).then((response) => response)
	},

	async updatePayment(paymentId, payload) {
		return await API.put(EndpointFinancial + EndpointPayment + `/${paymentId}`, payload, {
			headers: {
				'content-type': 'multipart/form-data',
			},
		}).then((response) => response)
	},

	async removePayment(id) {
		return await API.delete(EndpointFinancial + EndpointPayment + `/${id}/cancel`).then(
			(response) => response
		)
	},
}
